{
    const sidebarClassName = 'page-sidebar'
    const contentClassName = 'page-container'
    const expandedClassName = 'is-page-sidebar-expanded'
    const triggerExpandClassName = 'page-sidebar-trigger-expand'
    const triggerCollapseClassName = 'page-sidebar-trigger-collapse'
    const scrollbarWidth = () => window.innerWidth - document.body.clientWidth;
    const page = () => document.documentElement
    const sidebar = () => document.getElementsByClassName(sidebarClassName)[0]
    const content = () => [...document.querySelectorAll('.page-container, .sticky-header')]

    let focusElement = null;

    const all = () => {
        page().style.setProperty('--scrollbar-width', `${scrollbarWidth()}px`);
    }
    
    
    const expand = () => {
        all();
        focusElement = document.activeElement
        content().forEach(el => el.setAttribute('inert', 'inert'))
        sidebar().removeAttribute('inert')
        page().classList.add(expandedClassName)
    };
    
    const collapse = () => {
        all();
        sidebar().setAttribute('inert', 'inert')
        content().forEach(el => el.removeAttribute('inert'))
        page().classList.remove(expandedClassName)
        focusElement.focus()
    };

    const onClick = e => {
        const targetExpand = e.target.closest(`.${triggerExpandClassName}`)
        const targetCollapse = e.target.closest(`.${triggerCollapseClassName}`)
        if (targetExpand) {
            expand();
            return
        }
        if (targetCollapse) {
            collapse();
            return
        }
    }

    document.addEventListener('click', onClick)
    document.addEventListener('keypress', onClick)
}



